import React, { useState } from "react";
import FormContact from "./FormContact";
import { FormContext } from "../../FormContext";

const AppContact: React.FC = () => {
    // Information
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [number, setNumber] = useState<string>("");
    const [company, setCompany] = useState<string>("");
    const [occupation, setOccupation] = useState<string>("");
    const [service, setService] = useState<string>("");
    const [source, setSource] = useState<string>("");

    // Step
    const [stepPersonalInformation, setStepPersonalInformation] = useState<boolean>(true);

    const [stepSuccess, setStepSuccess] = useState<boolean>(false);
    const [stepFailed, setStepFailed] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const handleValidation = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError(false);

        if (!name || !email || !number || !company || !occupation || !service || !source) {
            setError(true);
            setIsLoading(false);
            return;
        }

        try {
            const formData = new FormData();
            const baseUrl = `${process.env.REACT_APP_API_URL}/contact-us`;

            formData.append("name", name);
            formData.append("email", email);
            formData.append("number", number);
            formData.append("company", company);
            formData.append("occupation", occupation);
            formData.append("service", service);
            formData.append("source", source);

            const response = await fetch(baseUrl, {
                method: "POST",
                body: formData
            });

            if (!response.ok) {
                setIsLoading(false);
                setStepFailed(true);
                setStepPersonalInformation(false);
                
            } else {
                const result = await response.json();
                console.log("Success:", result);

                setIsLoading(false);
                setStepSuccess(true);
                setStepPersonalInformation(false);
            }
        } catch (error) {
            console.log("Error:", error);
            setIsLoading(false);
            setStepFailed(true);
            setStepPersonalInformation(false);
        }
    };

    const contextValues = {
        isLoading,
        error,
        stepSuccess,
        stepFailed,

        // Information
        name,
        setName,
        email,
        setEmail,
        number,
        setNumber,
        company,
        setCompany,
        occupation,
        setOccupation,
        service,
        setService,
        source,
        setSource,

        stepPersonalInformation,
        setStepPersonalInformation,

        handleValidation
    };

    return (
        <FormContext.Provider value={contextValues}>
            <div className="bg-slate-200 w-full">
                <FormContact />
            </div>
        </FormContext.Provider>
    );
};

export default AppContact;
